import React, { useEffect, useState } from "react";
import { useLocation, Link,  useParams } from "react-router-dom";

import axios from "axios";
import { Helmet } from "react-helmet";

const API_BASE = "https://phpstack-1434504-6130285.cloudwaysapps.com";

const abs = (u) => (!u ? null : u.startsWith("http") ? u : `${API_BASE}${u}`);
const replaceTokens = (s, loc) => (typeof s === "string" ? s.replace(/\{locationName\}/gi, loc || "") : s);
 
/** Try multiple endpoints + both shapes (flat / attributes) */
async function fetchBySlug(slug, cancelToken) {
  const endpoints = ["/api/articles", "/api/master-blogs"];
  for (const ep of endpoints) {
    // try case-insensitive match first, then exact (some Strapi builds don't support $eqi)
    const tries = [
      `${API_BASE}${ep}?filters[slug][$eqi]=${encodeURIComponent(slug)}&populate=*&publicationState=live&pagination[pageSize]=1`,
      `${API_BASE}${ep}?filters[slug][$eq]=${encodeURIComponent(slug)}&populate=*&publicationState=live&pagination[pageSize]=1`,
    ];
    for (const url of tries) {
      try {
        const res = await axios.get(url, { cancelToken });
        const item = res?.data?.data?.[0];
        if (!item) continue;

        // normalize
        const raw = item.attributes ? { id: item.id, ...item.attributes } : item;

        // Some media may be nested (image.data.attributes)
        const img =
          raw.image?.data?.attributes ||
          raw.image?.formats?.large ||
          raw.image?.formats?.medium ||
          raw.image;

        const og =
          raw.og_image?.data?.attributes ||
          raw.og_image?.formats?.large ||
          raw.og_image;

        return {
          ok: true,
          data: {
            id: raw.id,
            title: raw.title || "",
            slug: raw.slug || slug,
            html: raw.description || "",
            metaTitle: raw.meta_title || raw.title || "",
            metaDesc: raw.meta_description || "",
            imageUrl: abs(img?.url),
            ogUrl: abs(og?.url),
            tags:
              raw.tags?.data?.map((t) => t.attributes || t) ||
              raw.tags ||
              [],
            category:
              raw.category?.data?.attributes ||
              raw.category ||
              null,
            createdAt: raw.createdAt,
            updatedAt: raw.updatedAt,
            publishedAt: raw.publishedAt,
          },
        };
      } catch (e) {
        if (axios.isCancel(e)) return { ok: false };
        // keep looping to next try/endpoint
        // console.warn("fetch try failed:", e?.response?.status, ep);
      }
    }
  }
  return { ok: false };
}

export default function Mainproductpage() {
  const { treatmentSlug } = useParams();
  const loc = useLocation();

  // fallback in case route params not present
  const parts = loc.pathname.split("/").filter(Boolean);
  const locationSlug = parts[1] || "india";
  const slug = treatmentSlug || parts[parts.length - 1];

  const [state, setState] = useState({ loading: true, error: "", item: null });

  useEffect(() => {
    if (!slug) return;
    let cancel;
    setState({ loading: true, error: "", item: null });

    (async () => {
      const res = await fetchBySlug(
        slug,
        new axios.CancelToken((c) => (cancel = c))
      );
      if (!res.ok) {
        setState({
          loading: false,
          error: `No content found for "${slug}".`,
          item: null,
        });
        return;
      }
      const item = res.data;

      // replace {locationName} in all textish fields
      item.title = replaceTokens(item.title, locationSlug);
      item.metaTitle = replaceTokens(item.metaTitle, locationSlug);
      item.metaDesc = replaceTokens(item.metaDesc, locationSlug);
      item.html = replaceTokens(item.html, locationSlug);

      setState({ loading: false, error: "", item });
    })();

    return () => cancel && cancel();
  }, [slug, locationSlug]);

  if (state.loading) {
    return (
      <div id="colorlib-main">
        <section className="ftco-section ftco-no-pt ftco-no-pb">
          <div className="container py-5"><p>Loading...</p></div>
        </section>
      </div>
    );
  }

  if (state.error || !state.item) {
    return (
      <div id="colorlib-main">
        <section className="ftco-section ftco-no-pt ftco-no-pb">
          <div className="container py-5">
            <p style={{ color: "#6c757d" }}>{state.error || "No content."}</p>
          </div>
        </section>
      </div>
    );
  }

  const { title, metaTitle, metaDesc, imageUrl, ogUrl, html, tags } = state.item;

  return (
    <div id="colorlib-main">
      <Helmet>
        <title>{metaTitle}</title>
        {metaDesc ? <meta name="description" content={metaDesc} /> : null}
        {ogUrl ? <meta property="og:image" content={ogUrl} /> : null}
        <meta property="og:title" content={metaTitle} />
        {metaDesc ? <meta property="og:description" content={metaDesc} /> : null}
      </Helmet>

      <section className="ftco-section ftco-no-pt ftco-no-pb">
        <div className="container">
          <div className="row d-flex">
            <div className="col-lg-8 px-md-5 pt-0">
              <div className="row pt-md-4 p-3">
                <h1 className="mb-3">
                  <span className="textgreen">{title}</span>
                </h1>

                {imageUrl && (
                  <p>
                    <img src={imageUrl} alt={title} className="img-fluid" />
                  </p>
                )}

                {/* HTML content */}
                <div
                  className="article-content"
                  dangerouslySetInnerHTML={{ __html: html }}
                />

                {/* <div className="about-author d-flex p-4 bg-light">
                  <div className="bio mr-5">
                    <img src="../img/withouttext.png" alt="MedCare Trust logo" className="img-fluid mb-4" />
                  </div>
                  <div className="desc">
                    <h3>Join Our Community</h3>
                  </div>
                </div>

                <div className="pt-5 mt-5">
                  <h3 className="mb-5 font-weight-bold">Comments</h3>
                </div> */}
              </div>
            </div>

            {/* SIDEBAR */}
            <div className="col-xl-4 sidebar bg-light pt-5 position-relative">
              <div className="sidebar-box pt-md-4">
                            <Link to={`../blog/${locationSlug}/search`}>
                                <form action="#" className="search-form" onSubmit={(e)=>e.preventDefault()}>
              <div className="form-group">
                <span className="icon ri-search-line"></span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Your Blog..."
                  readOnly
                />
              </div>
              </form>
            </Link>
            
                            </div>

              <div className="sidebar-box ">
                <h3 className="sidebar-heading">Find Your Tag</h3>
             <ul className="tagcloud">
                {Array.isArray(tags) && tags.length > 0 ? (
                  tags.map((t) => (
                    <a
                      href={`/blog/${locationSlug}/${t.slug}`} // 👈 slug from your API
                      key={t.id || t.title || t.name}
                      className="tag-cloud-link"
                      style={{ cursor: "pointer" }}
                    >
                      {t.title || t.name}
                    </a>
                  ))
                ) : (
                  <a className="tag-cloud-link" style={{ cursor: "default" }}>
                    Untagged
                  </a>
                )}
              </ul>

              </div>

                <div className="sidebar-box" style={{position:"sticky", top:"20px"}}>
                  
                <h3 className="sidebar-heading">About Us</h3>
                   <p className="text-lg mb-4">
                   Picano Interio LLP, established in 2003, stands as a prominent player in the realm of furniture manufacturing, particularly renowned for its excellence in crafting top-notch classroom furniture.🌍❤{" "}
                    <strong style={{ color: "rgb(198 87 160)" }}>
                      #Picanoindia #Furniture
                    </strong>
                  </p>

                  <h3 className="sidebar-heading">Follow Us</h3>
               <div className="social-icons mt-3 d-flex flex-wrap gap-3" style={{ fontSize: "22px" }}>
                                  {/* social links (unchanged) */}
                                  <Link to="https://www.facebook.com/PicanoSchoolFurnitureManufacturer/" target="_blank" rel="noopener noreferrer"><i className="ri-facebook-fill"></i></Link>
                                  <Link to="https://www.instagram.com/picanoin/" target="_blank" rel="noopener noreferrer" title="Instagram India"><i className="ri-instagram-line"></i></Link>
                                  {/* <Link to="https://www.youtube.com/@MedCareTrust" target="_blank" rel="noopener noreferrer" title="YouTube India"><i className="ri-youtube-fill"></i></Link>
                                  <Link to="https://www.linkedin.com/company/medcaretrust" target="_blank" rel="noopener noreferrer" title="LinkedIn"><i className="ri-linkedin-fill"></i></Link>
                                  <Link to="https://x.com/medcaretrust" target="_blank" rel="noopener noreferrer" title="X (Twitter)"><i className="ri-twitter-fill"></i></Link>
                                  <Link to="https://t.me/MedCareTrust" target="_blank" rel="noopener noreferrer" title="Telegram Channel"><i className="ri-telegram-line"></i></Link>
                                  <Link to="https://chat.whatsapp.com/HNHGSzccqC0G3yEauXJrz9" target="_blank" rel="noopener noreferrer" title="WhatsApp Community"><i className="ri-whatsapp-line"></i></Link>
                                  <Link to="https://www.reddit.com/user/MedCareTrust/" target="_blank" rel="noopener noreferrer" title="Reddit"><i className="ri-reddit-line"></i></Link>
                                  <Link to="https://medium.com/@MedCareTrust" target="_blank" rel="noopener noreferrer" title="Medium"><i className="ri-medium-line"></i></Link>
                                  <Link to="https://open.spotify.com/show/2YRcfGsYA36ziRd14pIaln?si=eafbf9c317c74562" target="_blank" rel="noopener noreferrer" title="Spotify Podcast"><i className="ri-spotify-line"></i></Link>
                                  <Link to="http://wasap.my/919915447777" target="_blank" rel="noopener noreferrer" title="WhatsApp Direct"><i className="ri-whatsapp-line"></i></Link>
                                  <Link to="https://www.quora.com/profile/MedCareTrust" target="_blank" rel="noopener noreferrer" title="Quora"><i className="ri-quora-line">Q</i></Link>
                                  <Link to="https://www.instagram.com/medcaretrustbangladesh/" target="_blank" rel="noopener noreferrer" title="Instagram Bangladesh"><i className="ri-instagram-line"></i></Link>
                                  <Link to="https://www.youtube.com/@MedCareTrustBangladesh786" target="_blank" rel="noopener noreferrer" title="YouTube Bangladesh"><i className="ri-youtube-fill"></i></Link>
                                     <Link to="https://aratt.ai/@medcare_trust" target="_blank" rel="noopener noreferrer" title="aratt medcare"> <img
                        className="w-75 entered lazyloaded"
                        src={require("./images/AI.png")}
                        alt={`Medcare trust `} 
                      /></Link> */}
                                </div>
                </div>
            </div>
            {/* END SIDEBAR */}
          </div>
        </div>
      </section>
    </div>
  );
}
